import { useMemo, useState } from "react";
import { SortOrder } from "@common/constants";
import { BillSort, BillSortValue } from "@common/types/bill";

const DEFAULT_SORT = BillSortValue.DATE_DESC;

export interface UseSort {
    currentSort: BillSortValue;
    handleSortChange: (value: BillSortValue) => void;
    sortExpression: BillSort | undefined;
}

export const getSortExpression = (sort: BillSortValue) => {
    switch (sort) {
        case BillSortValue.DATE_DESC:
            return {
                field: "date",
                order: SortOrder.DESC,
            };
        case BillSortValue.DATE_ASC:
            return {
                field: "date",
                order: SortOrder.ASC,
            };
        case BillSortValue.DUE_DATE_DESC:
            return {
                field: "dueDate",
                order: SortOrder.DESC,
            };
        case BillSortValue.DUE_DATE_ASC:
            return {
                field: "dueDate",
                order: SortOrder.ASC,
            };
        case BillSortValue.STATUS_ASC:
            return {
                field: "status",
                order: SortOrder.ASC,
            };
        case BillSortValue.STATUS_DESC:
            return {
                field: "status",
                order: SortOrder.DESC,
            };
        case BillSortValue.EXTERNAL_STATUS_ASC:
            return {
                field: "externalStatus",
                order: SortOrder.ASC,
            };
        case BillSortValue.EXTERNAL_STATUS_DESC:
            return {
                field: "externalStatus",
                order: SortOrder.DESC,
            };
        case BillSortValue.COUNTERPARTY_ASC:
            return {
                field: "counterparty",
                order: SortOrder.ASC,
            };
        case BillSortValue.COUNTERPARTY_DESC:
            return {
                field: "counterparty",
                order: SortOrder.DESC,
            };
        case BillSortValue.ACCOUNT_DESC:
            return {
                field: "financialAccount",
                order: SortOrder.DESC,
            };
        case BillSortValue.ACCOUNT_ASC:
            return {
                field: "financialAccount",
                order: SortOrder.ASC,
            };
        case BillSortValue.AMOUNT_DESC:
            return {
                field: "amount",
                order: SortOrder.DESC,
            };
        case BillSortValue.AMOUNT_ASC:
            return {
                field: "amount",
                order: SortOrder.ASC,
            };
        case BillSortValue.NONE:
            return undefined;
        default:
            return undefined;
    }
};

export function useSort(defaultSort: BillSortValue = DEFAULT_SORT): UseSort {
    const [currentSort, setCurrentSort] = useState<BillSortValue>(defaultSort);

    const sortExpression: BillSort | undefined = useMemo(
        () => getSortExpression(currentSort),
        [currentSort],
    );

    return {
        currentSort,
        handleSortChange: setCurrentSort,
        sortExpression,
    };
}
